
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { NewsArticle } from "@/pages/admin/news/types";
import { Badge } from "./ui/badge";
import { X } from "lucide-react";
import { useState } from "react";

interface ArticleDialogProps {
  article: NewsArticle | null;
  isOpen: boolean;
  onClose: () => void;
}

export function ArticleDialog({ article, isOpen, onClose }: ArticleDialogProps) {
  const [imageError, setImageError] = useState(false);
  
  if (!article) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex justify-between items-start">
            <DialogTitle className="text-2xl">{article.title}</DialogTitle>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <X className="h-4 w-4" />
            </Button>
          </div>
          <div className="flex justify-between items-center my-2">
            <Badge variant="outline">
              {article.category === "news" ? "Νέα & Ενδιαφέροντα" : "Τεχνολογικές Εξελίξεις"}
            </Badge>
            <span className="text-sm text-muted-foreground">{article.date}</span>
          </div>
          <DialogDescription className="text-lg">{article.description}</DialogDescription>
        </DialogHeader>

        {article.image && !imageError && (
          <div className="w-full h-64 my-4 overflow-hidden rounded-md">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover"
              onError={(e) => {
                console.error("Image failed to load:", article.image);
                setImageError(true);
              }}
            />
          </div>
        )}
        
        {(imageError || !article.image) && (
          <div className="w-full h-64 my-4 overflow-hidden rounded-md bg-gray-100 flex items-center justify-center">
            <p className="text-gray-500">Η εικόνα δεν είναι διαθέσιμη</p>
          </div>
        )}

        <div className="space-y-4 my-4">
          <div className="whitespace-pre-wrap">{article.content}</div>
        </div>

        <DialogFooter>
          <Button onClick={onClose}>Κλείσιμο</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
